var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import ReactDOM from "react-dom";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, IconButton, Paper, TextField, } from "@material-ui/core";
import { Add, Image } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { useCreatePlaylistBusinessTypeFromForm } from "frontend/src/domain/playlist-business-type";
import { ButtonLoader } from "frontend/src/ui/button-loader";
export var AddPlaylistBusinessType = function () {
    var _a = __read(React.useState(false), 2), isOpen = _a[0], setOpen = _a[1];
    var close = function () { return setOpen(false); };
    var open = function () { return setOpen(true); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { color: "primary", variant: "outlined", startIcon: React.createElement(Add, null), onClick: open }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C"),
        ReactDOM.createPortal(React.createElement(Modal, { isOpen: isOpen, onClose: close }), document.body)));
};
var useStyles = makeStyles({
    label: {
        display: "inline-block",
    },
    iconButton: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    },
    image: {
        position: "relative",
        height: 200,
        width: 200,
        backgroundImage: function (_a) {
            var image = _a.image;
            return "url(".concat(image, ")");
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        "& .MuiButtonBase-root": {
            display: function (_a) {
                var image = _a.image;
                return (image ? "none" : "inline-block");
            },
        },
        "&:hover .MuiButtonBase-root": {
            display: "inline-block",
        },
    },
});
var Modal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var _b = useCreatePlaylistBusinessTypeFromForm(), image = _b.image, title = _b.title, onSubmit = _b.onSubmit, isLoading = _b.isLoading, isSuccess = _b.isSuccess;
    var classes = useStyles({
        image: image.value,
    });
    var ref = React.createRef();
    React.useEffect(function () {
        return image.reset;
    }, []);
    React.useEffect(function () {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess]);
    return (React.createElement(Dialog, { open: isOpen, onClose: onClose, fullWidth: true, maxWidth: "sm" },
        React.createElement("form", { onSubmit: onSubmit },
            React.createElement(DialogTitle, null, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044E"),
            React.createElement(DialogContent, null,
                React.createElement(Box, null,
                    React.createElement("input", { hidden: true, type: "file", accept: "image/*", ref: ref, onChange: image.onChange }),
                    React.createElement(Box, { component: Paper, className: classes.image },
                        React.createElement(IconButton, { className: classes.iconButton, onClick: function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click(); } },
                            React.createElement(Image, { fontSize: "large", htmlColor: "grey" }))),
                    image.error && (React.createElement(FormHelperText, { error: true }, image.error))),
                React.createElement(Box, { mt: 1 },
                    React.createElement(TextField, { label: "Название", fullWidth: true, value: title.value, onChange: title.onChange, error: Boolean(title.error), helperText: title.error }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: onClose, color: "primary" }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"),
                React.createElement(ButtonLoader, { isLoading: isLoading, color: "primary", type: "submit" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
};
